// extracted by mini-css-extract-plugin
module.exports = {"container":"NewArticleForm_container__3yYU_","bodyInput":"NewArticleForm_bodyInput__gfuUA"};